/** One music acknowledgement block (track + links + license). */

export interface MusicCreditLink {
    href: string;
    label: string;
}

export interface MusicCreditLicense {
    summary: string;
    deedHref: string;
    deedLabel: string;
}

export interface MusicCredit {
    trackTitle: string;
    artist: string;
    primaryLink: MusicCreditLink;
    royaltyFreeLink: MusicCreditLink;
    license: MusicCreditLicense;
}

const FREE_STOCK_MUSIC: MusicCreditLink = {
    href: 'https://www.free-stock-music.com',
    label: 'free-stock-music.com',
};

const CREATORCHORDS: MusicCreditLink = {
    href: 'https://creatorchords.com',
    label: 'creatorchords.com',
};

const CC_BY_4: MusicCreditLicense = {
    summary: 'Creative Commons / Attribution 4.0 International (CC BY 4.0)',
    deedHref: 'https://creativecommons.org/licenses/by/4.0/',
    deedLabel: 'creativecommons.org/licenses/by/4.0/',
};

function nakaradaTrack(trackTitle: string): MusicCredit {
    return {
        trackTitle,
        artist: 'Alexander Nakarada (CreatorChords)',
        primaryLink: CREATORCHORDS,
        royaltyFreeLink: FREE_STOCK_MUSIC,
        license: CC_BY_4,
    };
}

/**
 * Music credits in display order. The Credits page lays them out in a responsive grid
 * (left → right, then wrap). Append new entries here.
 */
export const MUSIC_CREDITS: MusicCredit[] = [
    nakaradaTrack('The Great Battle'),
    nakaradaTrack('Hymn To The Gods'),
    nakaradaTrack('Sunguard'),
    {
        trackTitle: 'memories of the sea',
        artist: 'Rexlambo',
        primaryLink: {
            href: 'https://soundcloud.com/rexlambo',
            label: 'soundcloud.com/rexlambo',
        },
        royaltyFreeLink: FREE_STOCK_MUSIC,
        license: {
            summary: 'Creative Commons / Attribution 3.0 Unported License (CC BY 3.0)',
            deedHref: 'https://creativecommons.org/licenses/by/3.0/deed.en_US',
            deedLabel: 'creativecommons.org/licenses/by/3.0/deed.en_US',
        },
    },
];
